export default __webpack_public_path__ + "static/media/374D.b62f1f1e.jpg";